export default __webpack_public_path__ + "static/custom-img-4-8af1a19a1308420ec4126a8623d82482.webp";